import { IComposedReportFilters } from 'legacy/lut/components/widgets/public/partner360/composedReport'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'

import { IColumn } from 'core-components/library/list/types'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { FiltersView } from './components/filtersView/FiltersView'

export const columns: IColumn<IComposedReportFilters>[] = [
  {
    field: 'Name',
    title: `${TRANSLATION_KEYS.savedFiltersDialogName}`,
    priority: 1,
  },
  {
    field: 'Modified',
    title: `${TRANSLATION_KEYS.savedFiltersDialogModifiedDate}`,
    priority: 1,
    renderFunction: (item: IComposedReportFilters) => {
      return <>{getFormatDate(item.Modified, 'full')}</>
    },
  },
  {
    field: 'Filters',
    title: `${TRANSLATION_KEYS.savedFiltersDialogFilters}`,
    priority: 1,
    renderFunction: (item: IComposedReportFilters) => {
      return <FiltersView item={item} />
    },
  },
]
